<template>
  <nuxt-child />
</template>

<script>
export default {
  scrollToTop: true,
  head() {
    return {
      title: this.$t('services.title'),
      meta: [
        // hid is used as unique identifier. Do not use `vmid` for it as it will not work
        {
          hid: 'description',
          name: 'description',
          content: this.$t('services.description'),
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: this.$t('services.description'),
        },
        {
          hid: 'og:title',
          property: 'og:title',
          content: this.$t('services.title'),
        },
        {
          hid: 'og:url',
          property: 'og:url',
          content: `https://discontract.com${this.$route.path.replace(
            /\/?$/,
            '/'
          )}`,
        },
      ],
    };
  },
};
</script>
